import { createGlobalStyle } from 'styled-components';
import { fontFace } from './fonts/fonts';
import { breakpoints, focusOutline } from 'themes/helpers';

// form elements such as input, textarea, select, and button
// don't automatically inherit font-family
const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  ${fontFace}

  body {
  margin: 0;
  font-family: 'Helvetica Now for TELUS', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: ${({ theme }) => theme.palette.neutral.surface1};

  @media (min-width: ${() => breakpoints.tablet}px) {
    background-color: ${({ theme }) => theme.palette.neutral.surface2};
  }
  }

  :not(:lang(vi)) {
  // All langs except Vietnamese
  body {
    font-feature-settings:
      'salt' on,
      'ss01' on,
      'ss08' on,
      'ss04' on,
      'clig' off,
      'liga' off;
  }

  :lang(ar) {
  // Arabic (العربية)
    font-family: 'Helvetica Now for TELUS', 'Geeza Pro', 'Segoe UI', 'Calibri',
    'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

:lang(he) {
  // Hebrew (עברית)
  font-family: 'Helvetica Now for TELUS', 'Arial Hebrew', 'Segoe UI', 'Calibri',
    'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

:lang(ja) {
  // Japanese (日本語)
  font-family: 'Helvetica Now for TELUS', 'Hiragino Kaku Gothic Pro', 'Meiryo',
    'Osaka', 'MS PGothic', 'MS P', 'Helvetica Neue', 'Helvetica', 'Arial',
    sans-serif;
}

:lang(ru), // Russian (Русский)
:lang(uk) {
  // Ukranian (Українська)
  font-family: 'Helvetica Now for TELUS', 'Geneva', 'Segoe UI', 'Calibri',
    'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

:lang(zh-Hant) {
  // Traditional Chinese (繁体中文)
  font-family: 'Helvetica Now for TELUS', 'PingFang TC', 'Microsoft Jhenghei',
    'Apple LiGothic', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

:lang(zh-Hans) {
  // Simplified Chinese (简体中文)
  font-family: 'Helvetica Now for TELUS', 'PingFang SC', 'Microsoft Yahei',
    'STHeiti', 'Simhei', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

:lang(am) {
  // Amharic (አማርኛ)
  font-family: 'Helvetica Now for TELUS', 'Kefa', 'Ebrima', 'Nyala',
    'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}

:lang(hi), // Hindi (हिंदी)
:lang(ne) {
  // Nepali (नेपाली)
  font-family: 'Helvetica Now for TELUS', 'Kohinoor Devanagari', 'Nirmala UI',
    'Shree Devanagari 714', 'Mangal', 'Helvetica Neue', 'Helvetica', 'Arial',
    sans-serif;
}

:lang(th) {
  // Thai (ไทย)
  font-family: 'Helvetica Now for TELUS', 'Thonburi', 'Tahoma', 'Leelawadee UI',
    'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
}
}

  a {
    text-decoration: underline;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.primary600};
    ${focusOutline({})};
  }

  ul {
  padding: 0;
  margin: 0;
  }

  li {
    list-style: none;
  }

  bold {
    font-weight: 700;
  }
`;

export default GlobalStyle;
